export const DistanceUnits: { name: string; value: __esri.LinearUnits }[] = [
    { name: 'Feet', value: 'feet' },
    { name: 'Miles', value: 'miles' },
    { name: 'Kilometers', value: 'kilometers' },
    { name: 'Meters', value: 'meters' },
    { name: 'Nautical Miles', value: 'nautical-miles' },
    { name: 'Yards', value: 'yards' }
];
export const AreaUnits = [
    { name: 'Acres', value: 'acres' },
    { name: 'Square Feet', value: 'square-feet' },
    { name: 'Square Miles', value: 'square-miles' },
    { name: 'Square Meters', value: 'square-meters' },
    { name: 'Square Kilometers', value: 'square-kilometers' }
];

export const FillStyleOptions = [
    { name: 'Solid', value: 'solid' },
    { name: 'Backward Diagonal', value: 'backward-diagonal' },
    { name: 'Cross', value: 'cross' },
    { name: 'Diagonal Cross', value: 'diagonal-cross' },
    { name: 'Forward Diagonal', value: 'forward-diagonal' },
    { name: 'Horizontal', value: 'horizontal' },
    { name: 'Vertical', value: 'vertical' },
    { name: 'None', value: 'none' }
];

export const LineStyleOptionsForArcServer = [
    { name: 'Solid', value: 'solid' },
    { name: 'Dash', value: 'dash' },
    { name: 'Dash Dot', value: 'dash-dot' },
    { name: 'Dot', value: 'dot' }
];

export const LineStyleOptions = [
    { name: 'Solid', value: 'solid' },
    { name: 'Dash', value: 'dash' },
    { name: 'Dash Dot', value: 'dash-dot' },
    { name: 'Dot', value: 'dot' },
    { name: 'Long Dash', value: 'long-dash' },
    { name: 'Long Dash Dot', value: 'long-dash-dot' },
    { name: 'Long Dash Dot Dot', value: 'long-dash-dot-dot' },
    { name: 'Short Dash', value: 'short-dash' },
    { name: 'Short Dash Dot', value: 'short-dash-dot' },
    { name: 'Short Dash Dot Dot', value: 'short-dash-dot-dot' },
    { name: 'Short Dot', value: 'short-dot' }
];

export const LineStyleOptionsWithNull = [
    { name: 'Solid', value: 'solid' },
    { name: 'Dash', value: 'dash' },
    { name: 'Dot', value: 'dot' },
    { name: 'Dash Dot', value: 'dash-dot' },
    { name: 'Long Dash', value: 'long-dash' },
    { name: 'Long Dash Dot', value: 'long-dash-dot' },
    { name: 'Long Dash Dot Dot', value: 'long-dash-dot-dot' },
    { name: 'Null', value: 'none' },
    { name: 'Short Dash', value: 'short-dash' },
    { name: 'Short Dash Dot', value: 'short-dash-dot' },
    { name: 'Short Dash Dot Dot', value: 'short-dash-dot-dot' },
    { name: 'Short Dot', value: 'short-dot' }
];

export const baseScaleIntervals = [
    { label: 'States', value: 5000000 },
    { label: 'State', value: 2500000 },
    { label: 'District', value: 1250000 },
    { label: 'Counties', value: 600000 },
    { label: 'County', value: 300000 },
    { label: 'Metro Area', value: 150000 },
    { label: 'Cities', value: 75000 },
    { label: 'City', value: 37000 },
    { label: 'Town', value: 20000 },
    { label: 'Neighborhood', value: 10000 },
    { label: 'Streets', value: 5000 },
    { label: 'Street', value: 2500 },
    { label: 'Building', value: 1200 }
];

export const CrashAccidentCauseFlags = [
    { name: 'Aggressive Driving', value: 'AGGRESSIVE_DRIVING' },
    { name: 'NHTSA Aggressive Driving', value: 'NHTSA_AGG_DRIVING' },
    { name: 'Speeding Related', value: 'SPEEDING_RELATED' },
    { name: 'Alcohol Related', value: 'ALCOHOL_RELATED' },
    { name: 'Drinking Driver', value: 'DRINKING_DRIVER' },
    { name: 'Drug Related', value: 'DRUG_RELATED' },
    { name: 'Illegal Drug Related', value: 'ILLEGAL_DRUG_RELATED' },
    { name: 'Tailgating', value: 'TAILGATING' },
    { name: 'Phantom Vehicle', value: 'PHANTOM_VEHICLE' },
    { name: 'Fatigue or Asleep', value: 'FATIGUE_ASLEEP' },
    { name: 'Driver Using Cell Phone', value: 'CELL_PHONE' },
    { name: 'Distracted Driver', value: 'DISTRACTED' },
    { name: 'No Clearance', value: 'NO_CLEARANCE' },
    { name: 'Shoulder Related', value: 'SHLDR_RELATED' },
    { name: 'Curve in Road Driver Error', value: 'CURVE_DVR_ERROR' },
    { name: 'Driver Running Red Light', value: 'RUNNING_RED_LT' },
    { name: 'Driver Running Stop Sign', value: 'RUNNING_STOP_SIGN' },
    { name: 'Deer Related', value: 'DEER_RELATED' },
    { name: 'Vehicle Failure', value: 'VEHICLE_FAILURE' },
    { name: 'Illumination Dark', value: 'ILLUMINATION_DARK' },
    { name: 'Icy Road', value: 'ICY_ROAD' },
    { name: 'Snow Slush Road', value: 'SNOW_SLUSH_ROAD' },
    { name: 'Wet Road', value: 'WET_ROAD' }
];
export const CrashAccidentTypeFlags = [
    { name: 'Hit Barrier', value: 'HIT_BARRIER' },
    { name: 'Hit Bridge', value: 'HIT_BRIDGE' },
    { name: 'Hit Deer', value: 'HIT_DEER' },
    { name: 'Hit Embankment', value: 'HIT_EMBANKMENT' },
    { name: 'Hit Fixed Object', value: 'HIT_FIXED_OBJECT' },
    { name: 'Hit Guiderail', value: 'HIT_GDRAIL' },
    { name: 'Hit Guidrail End', value: 'HIT_GDRAIL_END' },
    { name: 'Hit Pole', value: 'HIT_POLE' },
    { name: 'Hit Tree or Shrub', value: 'HIT_TREE_SHRUB' },
    { name: 'Headon or Side Swipe', value: 'HO_OPPDIR_SDSWP' },
    { name: 'Cross Median', value: 'CROSS_MEDIAN' },
    { name: 'Overturned Vehicle', value: 'OVERTURNED' },
    { name: 'Rear End Collision', value: 'REAR_END' },
    { name: 'Single Vehicle Run Off Road', value: 'SV_RUN_OFF_RD' },
    { name: 'Work Zone', value: 'WORK_ZONE' }
];
